import Tooltip from '@mui/material/Tooltip';
import React from 'react';

interface TooltipProps {
  id: string;
  children: React.ReactElement;
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
  title?: string;
  className?: string;
}

const CustomTooltip: React.FC<TooltipProps> = ({
  id,
  placement = 'bottom',
  title,
  className,
  children,
  ...rest
}) => {
  return (
    <Tooltip
      id={id}
      placement={placement}
      title={title}
      className={className}
      {...rest}
    >
      <div>{children}</div>
    </Tooltip>
  );
};

export default CustomTooltip;
